export { default } from './TicketCarouselModal';
export * from './TicketCarouselModal';
